import { IOfferDescriptionItem } from 'models/offer-description-item.model';

import { Tax } from './tax.model';

import { OfferStatus } from './enums/offer-status.enum';
import { PricingUnitEnum } from './enums/pricing-unit.enum';
import { PricingItemScope } from './enums/pricing-item-scope.enum';
import { RoundedPriceEnum } from './enums/rounded-price.enum';
import { FuelIndexing } from './fuel-indexing.model';
import { Transport } from './transport.model';
import { OfferMerchandiseType } from './enums/offer-merchandise-type.enum';
import { ServiceTypeEnum } from './enums/offer-service-type.enum';

export class Offer {
  public id?: number;
  public alias?: string;
  public name?: string;
  public description?: string;
  public flexibilityDeadline?: number;
  public status?: OfferStatus;
  public measureUnit?: PricingUnitEnum;
  public itemScope?: PricingItemScope;
  public roundedUpPrice: boolean = false;
  public pickupAddressFloorNumber: boolean = false;
  public pickupComments: boolean = false;
  public pickupPhoneCallAnHourBefore: boolean = false;
  public pickupFloorUpstairQuotationNeeded: boolean = false;
  public pickupVatExoneration: boolean = false;
  public pickupTimeslotStart?: number;
  public pickupTimeslotStartDefault?: number;
  public pickupTimeslotEnd?: number;
  public pickupTimeslotEndDefault?: number;
  public pickupTimeslotRange?: number;
  public deliveryAddressFloorNumber: boolean = false;
  public deliveryComments: boolean = false;
  public deliveryPhoneCallAnHourBefore: boolean = false;
  public deliveryFloorUpstairQuotationNeeded: boolean = false;
  public deliveryVatExoneration: boolean = false;
  public deliveryTimeslotStart?: number;
  public deliveryTimeslotStartDefault?: number;
  public deliveryTimeslotEnd?: number;
  public deliveryTimeslotEndDefault?: number;
  public deliveryTimeslotRange?: number;
  public roundedPrice?: RoundedPriceEnum;
  public offerDescriptionItems: IOfferDescriptionItem[] = [];
  public productCode?: string;
  public weightingFactor?: number;
  public carbonEmissionFactor?: number;
  public activatedTax?: boolean;
  public taxes: Tax[] = [];
  public fuelIndexing?: FuelIndexing;
  public transporter!: Transport;
  public merchandiseType?: OfferMerchandiseType; // TODO: Utiliser MerchandiseType et non l'énum, à faire le const. et MAJ la méthode 'serialize' (ISO transport)
  public serviceType?: ServiceTypeEnum; // TODO: Utiliser ServiceType et non l'énum, à faire le const. et MAJ la méthode 'serialize' (ISO transport)
  public isControlledTemperature?: boolean;
  public isHazardousMaterial?: boolean;
  public isQuotation: boolean = false;
  public minTemperatureThreshold?: number;
  public maxTemperatureThreshold?: number;

  constructor(data: any = {}) {
    Object.assign(this, data);
    this.taxes = (data.taxes || []).map((tax: any) => new Tax(tax));
    this.fuelIndexing = data.fuelIndexing ? new FuelIndexing(data.fuelIndexing) : undefined;
  }

  public serialize(): any {
    return {
      id: this.id,
      alias: this.alias,
      name: this.name,
      description: this.description,
      flexibilityDeadline: this.flexibilityDeadline,
      status: this.status,
      measureUnit: this.measureUnit,
      itemScope: this.itemScope,
      roundedUpPrice: this.roundedUpPrice,
      pickupAddressFloorNumber: this.pickupAddressFloorNumber,
      pickupComments: this.pickupComments,
      pickupPhoneCallAnHourBefore: this.pickupPhoneCallAnHourBefore,
      pickupFloorUpstairQuotationNeeded: this.pickupFloorUpstairQuotationNeeded,
      pickupVatExoneration: this.pickupVatExoneration,
      pickupTimeslotStart: this.pickupTimeslotStart,
      pickupTimeslotStartDefault: this.pickupTimeslotStartDefault,
      pickupTimeslotEnd: this.pickupTimeslotEnd,
      pickupTimeslotEndDefault: this.pickupTimeslotEndDefault,
      pickupTimeslotRange: this.pickupTimeslotRange,
      deliveryAddressFloorNumber: this.deliveryAddressFloorNumber,
      deliveryComments: this.deliveryComments,
      deliveryPhoneCallAnHourBefore: this.deliveryPhoneCallAnHourBefore,
      deliveryFloorUpstairQuotationNeeded: this.deliveryFloorUpstairQuotationNeeded,
      deliveryVatExoneration: this.deliveryVatExoneration,
      deliveryTimeslotStart: this.deliveryTimeslotStart,
      deliveryTimeslotStartDefault: this.deliveryTimeslotStartDefault,
      deliveryTimeslotEnd: this.deliveryTimeslotEnd,
      deliveryTimeslotEndDefault: this.deliveryTimeslotEndDefault,
      deliveryTimeslotRange: this.deliveryTimeslotRange,
      roundedPrice: this.roundedPrice,
      offerDescriptionItems: this.offerDescriptionItems,
      productCode: this.productCode,
      weightingFactor: this.weightingFactor ? Math.round(this.weightingFactor * 10) / 10 : this.weightingFactor,
      carbonEmissionFactor: this.carbonEmissionFactor,
      activatedTax: this.activatedTax,
      taxes: (this.taxes || []).map((tax: Tax) => tax.serialize()),
      fuelIndexing: this.fuelIndexing ? this.fuelIndexing.serialize() : undefined,
      transporter: this.transporter,
      merchandiseType: this.merchandiseType,
      serviceType: this.serviceType,
      isControlledTemperature: this.isControlledTemperature,
      isHazardousMaterial: this.isHazardousMaterial,
      isQuotation: this.isQuotation,
      minTemperatureThreshold: this.minTemperatureThreshold,
      maxTemperatureThreshold: this.maxTemperatureThreshold,
    };
  }
}
